import { Backdrop, Button } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "../../../helpers/axios";
import { useToast } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, InputNumber } from "antd";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { CustomImageSelect } from "../../loans/components/ProductModal";
import { SecondaryTabGroup } from "../../../components";

const SlotAgent = (props) => {
    const toast = useToast();

    const loanProviderTypes = useSelector((state) =>
        state.settings?.loanProviderTypes?.filter(
            (item, index) => item?.id != "eea49ff4-655f-412e-8bb2-22e0cf8578db"
        )
    );

    const { editData, slot, formType } = props;
    const [animClass, setAnimClass] = useState("invisible translate-x-[100%]");
    const methods = useForm({
        defaultValues: {
            startDate: "",
            endDate: "",
            providerType: "",
            slotId: "",
        },
    });
    const {
        register,
        control,
        setValue,
        getValues,
        watch,
        formState: { errors },
    } = methods;
    const formValues = watch();

    const [formData, setFormData] = useState({
        id: "",
        edit: false,
    });
    const [loanProviders, setLoanProviders] = useState([]);
    const refreshLoanProviders = async (providerType) => {
        let resp = null;

        if (formType == "agent") {
            resp = await axios.post(
                `/admin/agent/list/all`,
                {
                    sortKey: "name",
                    sortOrder: "asc",
                }
            );
        } else {
            resp = await axios.post(
                `/admin/loan/provider/list/all`,
                {
                    sortKey: "name",
                    sortOrder: "asc",
                    providerType,
                }
            );
        }
        setLoanProviders(resp?.data?.data);
    };

    //console.log({ loanProviders });
    const handleHookSubmit = async (data) => {
        try {
            const { providerType, slotId, startDate, endDate } = data;
            const payload = {
                slot: slot,
                type: formType == "agent" ? "2" : "1",
                providerType: formType == "agent" ? "" : providerType,
                loanProvider: formType == "agent" ? "" : slotId,
                agent: formType == "agent" ? data.slotId : "",
                startDate: dayjs(startDate).format("YYYY-MM-DD"),
                endDate: dayjs(endDate).format("YYYY-MM-DD"),
            };
            //console.log({ payload });
            if (editData?.id) {
                const resp = await axios.put(
                    "/admin/premium/update/" + editData.id,
                    payload
                );
                if (resp?.data?.resp_code === 200) {
                    props.closePopUp(true);
                    toast({
                        description: "Premium updated successfully",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    });
                }
            } else {
                const resp = await axios.post("/admin/premium/create", payload);
                if (resp?.data?.resp_code === 200) {
                    props.closePopUp(true);
                    toast({
                        description: "Premium added successfully",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    });
                }
            }
        } catch (error) {
            console.error(error);
            error?.response?.data?.errors?.existing_slot_period &&
                toast({
                    description: error?.response?.data?.errors?.existing_slot_period,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
        }
    };

    useEffect(() => {
        (async () => {
            if (editData) {
                const {
                    id,
                    loanproviderinfo,
                    endDate,
                    startDate,
                    agent,
                    loanProvider,
                    agentinfo,
                } = editData;
                //console.log({ editData });
                setFormData({
                    ...formData,
                    id: id,
                    edit: true,
                });
                formType == "loanProvider" &&
                    setValue("providerType", loanproviderinfo?.type);
                setValue("slotId", formType == "agent" ? agent : loanProvider);
                formType == "agent" && refreshLoanProviders("");
                setValue("startDate", dayjs(startDate));
                setValue("endDate", dayjs(endDate));
                //console.log(getValues());
            }
        })();

        !editData &&
            loanProviderTypes[0] &&
            loanProviderTypes[0].id &&
            setValue("providerType", loanProviderTypes[0].id);
    }, []);

    useEffect(() => {
        if (formValues.providerType || formType == "agent")
            refreshLoanProviders(formValues.providerType);
    }, [formValues.providerType]);

    //console.log({ formValues });
    useEffect(() => {
        document.querySelector("body").classList.add("body_scroll_hid");
        setAnimClass("visible translate-x-[0%]");
        return () => {
            document.querySelector("body").classList.remove("body_scroll_hid");
            setAnimClass("invisible translate-x-[100%]");
        };
    }, []);

    return (
        <div className="flex bg-black bg-opacity-0 fixed z-[999]  w-[100%] h-full left-0 top-0">
            <Backdrop sx={{ color: "#fff" }} open={true} onClick={props.closePopUp} />
            <div
                className={`w-[550px] max-w-[100%] max-w-2xl bg-white absolute rounded-t-lg md:rounded-none bottom-0 h-[90%] md:h-[100%] right-0 max-h-screen overflow-y-scroll scBarHidden z-10 popupAnim ${animClass}`}
            >
                <div className="relative py-2 pt-14">
                    <div className="absolute bg-white w-[100%] top-0">
                        <div className="flex px-4 py-2 pt-4 md:px-8 md:py-4 justify-between items-center z-9 w-[100%]">
                            <h3 className="text-md font-bold tracking-[-.15px] capitalize">
                                {editData
                                    ? `Edit ${formType == "agent" ? "Agent" : "Loan Provider"
                                    } In Slot`
                                    : `Add ${formType == "agent" ? "Agent" : "Loan Provider"
                                    } In Slot`}
                            </h3>
                            <div
                                className="bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer"
                                onClick={() => props.closePopUp()}
                            >
                                <img src="/images/x-circle.svg" className="w-5 h-5" />
                            </div>
                        </div>
                    </div>
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(handleHookSubmit)} noValidate>
                            <div className="px-4 py-2 pt-4 md:px-8 md:py-4 md:pt-6 w-full">
                                {formType == "loanProvider" && (
                                    <div className="mt-[25px]">
                                        <label className="block mb-[6px] font-[500] text-[13px] text-[#495159] flex justify-between items-center">
                                            Type
                                        </label>
                                        <Controller
                                            control={control}
                                            name="providerType"
                                            rules={{
                                                required: true,
                                            }}
                                            defaultValue={loanProviderTypes[0]?.id}
                                            // createData.productType
                                            render={({ field }) => {
                                                return (
                                                    <SecondaryTabGroup
                                                        active={field.value}
                                                        onClick={(value) => {
                                                            //console.log({ value });
                                                            field.onChange(value);
                                                            setLoanProviders([]);
                                                            setValue("slotId", "");
                                                            refreshLoanProviders(value);
                                                        }}
                                                        tabs={loanProviderTypes}
                                                        customLabel={"name"}
                                                        customValue={"id"}
                                                    />
                                                );
                                            }}
                                        />
                                    </div>
                                )}
                                <div className="mt-[10px]">
                                    <label className="block mb-[6px] font-[500] text-[13px] text-[#495159] flex justify-between items-center">
                                        {formType == "agent" ? `Agent` : `Loan Provider`}
                                    </label>
                                    <Controller
                                        control={control}
                                        name={"slotId"}
                                        rules={{
                                            required: true,
                                        }}
                                        render={({ field }) => {
                                            return (
                                                <CustomImageSelect
                                                    error={errors?.slotId}
                                                    name={field.name}
                                                    placeholder={
                                                        formType == "agent"
                                                            ? "Select Agent"
                                                            : "Select Loan Provider"
                                                    }
                                                    onSelect={(lp) => {
                                                        field.onChange(lp?.id);
                                                    }}
                                                    value={field.value}
                                                    options={loanProviders}
                                                />
                                            );
                                        }}
                                    />
                                </div>
                                <div className="flex flex-wrap items-center mt-[25px] gap-[0px_10px] cus_date_pick">
                                    <label className="block w-full mb-[6px] text-[13px] text-[#495159] font-[500] flex justify-between items-center">
                                        Premium Date Period
                                    </label>
                                    <div className="datePickAnt">
                                        <Controller
                                            control={control}
                                            name="startDate"
                                            rules={{
                                                required: true,
                                            }}
                                            render={({ field }) => {
                                                return (
                                                    <DatePicker
                                                        placeholder="DD-MM-YYYY"
                                                        status={errors?.startDate ? "error" : null}
                                                        name={field.name}
                                                        ref={field.ref}
                                                        format={"DD-MM-YYYY"}
                                                        className={`py-[8px]`}
                                                        value={field.value ? dayjs(field.value) : null}
                                                        onChange={(date) => {
                                                            field.onChange(date ? date.valueOf() : null);
                                                            if (date?.isAfter(formValues.endDate))
                                                                setValue("endDate", "");
                                                        }}
                                                        disabledDate={(d) =>
                                                            d.isBefore(dayjs().subtract(1, "day"))
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                    </div>
                                    <span className="mx-[10px] max-[500px]:w-full max-[500px]:my-[10px]">
                                        To
                                    </span>
                                    <div className="datePickAnt">
                                        <Controller
                                            control={control}
                                            name="endDate"
                                            rules={{
                                                required: true,
                                            }}
                                            render={({ field }) => {
                                                return (
                                                    <DatePicker
                                                        placeholder="DD-MM-YYYY"
                                                        status={errors?.endDate ? "error" : null}
                                                        name={field.name}
                                                        ref={field.ref}
                                                        disabledDate={(current) => {
                                                            return !formValues.startDate
                                                                ? false
                                                                : !current ||
                                                                current.isBefore(formValues.startDate) ||
                                                                current.isSame(formValues.startDate);
                                                        }}
                                                        format={"DD-MM-YYYY"}
                                                        className={`py-[8px]`}
                                                        value={field.value ? dayjs(field.value) : null}
                                                        onChange={(date) => {
                                                            field.onChange(date ? date.valueOf() : null);
                                                        }}

                                                    />
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="mt-[40px]">
                                    <Button type="submit" className="sav_btn">
                                        {editData ? `Update` : `Create`}
                                    </Button>
                                    <Button
                                        type="button"
                                        className="can_btn"
                                        onClick={() => props.closePopUp()}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </FormProvider>
                </div>
            </div>
        </div>
    );
};

export default SlotAgent;
